module.exports = __webpack_public_path__ + "img/4-1.0a8cac57.jpg";